import ProductForm from "../components/ProductForm";
import { VariantRadios, VariantSelects, QuantityInput } from "../components/ProductFormControls";
import Cart from "../components/Cart";
import CartItems from "../components/CartItems";
import CartRemove from "../components/CartRemove";
import CartAdd from "../components/CartAdd";
import Accordion, { ExpandIcon } from "../components/Accordion";
import AnnouncementBar from "../components/AnnouncementBar";
// import FocusTrap from "../components/FocusTrap";
// import * as focusTrap from 'focus-trap'; // ESM
import { BuildABox, BuildABoxProduct } from "../components/BuildABox";
// import EditBuildABox from "../components/EditABox";
import CarouselWrapper from "../components/Carousel";
import GridCarouselWrapper from "../components/GridCarousel";
import ImagesPop from "../components/ImagesPop";
import ProductCarousel from "../components/ProductCarousel";
import CandyRain from "../components/CandyRain";
import ClipboardCopy from "../components/ClipboardCopy";
import { FilterForm, FilterRemove, FilterToggle } from "../components/FilterSort";
import LottieItem from "../components/Lottie";
// import { NavMenu, Search } from "../components/Navigation";
// import { SiteSearchTrigger } from "../components/Search";
import Pagination from "../components/Pagination";
import ProductTypes from "../components/ProductTypes";
import Quickshop from "../components/Quickshop";
import ScrollMoment from "../components/ScrollMoment";
import Drawer from "../components/Drawer";
import { setCartProxy } from "../helpers";
import VideoPlayer from "../components/VideoPlayer";
import LoginWrapper from "../components/Login";
import Address from "../components/Address"
import Modal from "../components/Modal";
import AnchorButtons from "../components/AnchorButtons";
import ScrollTicker from "../components/ScrollTicker";
import PageSelect from "../components/PageSelect";
import ScrollMoment2 from "../components/ScrollMoment2";
import FreeProducts from "../components/FreeProducts";
import YotpoHeader from "../components/YotpoHeader";
import { AddPreBuiltBundle } from "../components/AddPreBuiltBundle";
import { FaqFromPage } from "../components/FaqFromPage";
import CountdownComponent from "../components/CountdownComponent";
import CountUpElement from "../components/CountUpElement";
import InlineSvg from "../components/InlineSvg";
import { FloatingIcon } from "../components/FloatingIcon";
import ArchedTitle from "../components/ArchedTitle";
import VideoTimeline from "../components/VideoTimeline";
import StickyAddToCart from "../components/StickyAddToCart";
import Tickertape from "../components/Tickertape";
import SlideWithColumns from "../components/SlideWithColumns";

/**
 * Our class wrapper for initializing custom elements
 * @property {Function} init onReady initializes our custom elements
 */
export default class Components {

	/**
	 * @arg {object} opts — Options
	 * @constructor
	 */
	constructor(opts = {}) {

	}

	init() {

		/** Before customElements */
		window.Zero = window.Zero || {};
		// window.Zero.FocusTrap = focusTrap;
		window.Zero.hasRun = window.Zero.hasRun || false;
		window.Zero.Currency = window.Zero.Currency || {
			rate: (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.rate : 1.0,
			locale: (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.active : "USD"
		};
		window.Zero.Intl = window.Zero.Intl || new Intl.NumberFormat(undefined, {
			style: "currency",
			currency: window.Zero.Currency.locale
		});

		/** Custom elements */
		if(window.Zero.hasRun === false) {

			// customElements.define("nav-menu", NavMenu);
			// customElements.define("site-search", Search);
			// customElements.define("site-search-trigger", SiteSearchTrigger);
			customElements.define("announcement-bar", AnnouncementBar);
			customElements.define("cart-wrapper", Cart);
			customElements.define("cart-item", CartItems);
			customElements.define("cart-remove", CartRemove);
			customElements.define("cart-add", CartAdd);
			customElements.define("variant-selects", VariantSelects);
			customElements.define("variant-radios", VariantRadios);
			customElements.define("quantity-input", QuantityInput);
			customElements.define("product-form", ProductForm);
			customElements.define("product-types", ProductTypes);
			customElements.define("accordion-tab", Accordion);
			customElements.define("expand-icon", ExpandIcon);
			customElements.define("carousel-default", CarouselWrapper);
			customElements.define("carousel-grid", GridCarouselWrapper);
			customElements.define("filter-form", FilterForm);
			customElements.define("filter-remove", FilterRemove);
			customElements.define("toggle-filters", FilterToggle);
			customElements.define("lottie-file", LottieItem);
			customElements.define("quickshop-trigger", Quickshop);
			customElements.define("paginate-grid", Pagination);
			customElements.define("build-a-box", BuildABox);
			customElements.define("build-a-box-product", BuildABoxProduct);
			// customElements.define("edit-subscription-box", EditBuildABox);
			customElements.define("clipboard-copy", ClipboardCopy);
			customElements.define("scroll-moment", ScrollMoment);
			customElements.define("scroll-moment-2", ScrollMoment2);
			customElements.define("slot-drawer", Drawer);
			customElements.define("video-player", VideoPlayer);
			customElements.define("login-wrapper", LoginWrapper);
			customElements.define("address-wrapper", Address);
			customElements.define("modal-popup", Modal);
			customElements.define("candy-rain", CandyRain);
			customElements.define("images-pop", ImagesPop);
			customElements.define("anchor-buttons", AnchorButtons);
			customElements.define("scroll-ticker", ScrollTicker);
			customElements.define("product-carousel", ProductCarousel);
			customElements.define("page-select", PageSelect);
			customElements.define("free-products", FreeProducts);
			customElements.define("yotpo-header", YotpoHeader);
			customElements.define("add-pre-built-bundle", AddPreBuiltBundle);
			customElements.define("countdown-component", CountdownComponent);
			customElements.define("faq-from-page", FaqFromPage);
			customElements.define("count-up", CountUpElement);
			customElements.define("inline-svg", InlineSvg);
			customElements.define("floating-icon", FloatingIcon);
			customElements.define("arched-title", ArchedTitle);
			customElements.define("video-timeline", VideoTimeline);
			customElements.define("sticky-add-to-cart", StickyAddToCart);
			customElements.define("ticker-tape", Tickertape);
			customElements.define("slide-with-columns", SlideWithColumns);

			// Count up on screeen
			window.countUpObserver = new IntersectionObserver(entries => {
				entries.forEach(entry => {

					if (entry.intersectionRatio > 0 && entry.target.countUp && !entry.target.countUp.error) {
						entry.target.countUp.reset();
						entry.target.countUp.start();
					}
				})
			});

			setTimeout(() => {
				document.querySelectorAll('count-up').forEach(countUp => {
					window.countUpObserver.observe(countUp);
				})
			}, 1000);



			/** Invokations */
			setCartProxy();

			window.Zero.hasRun = true;
		}
	}
}

